/**
 * Persist TradingView chart layouts (drawings, studies, intervals) in localStorage.
 * Used so marks/support lines survive page reload.
 */

export const CHART_STATE_KEYS = {
  futures: 'tv_chart_state_futures',
  spot: 'tv_chart_state_spot',
};

export function loadChartState(storageKey) {
  try {
    const raw = localStorage.getItem(storageKey);
    if (!raw) return undefined;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : undefined;
  } catch {
    return undefined;
  }
}

export function saveChartState(storageKey, state) {
  try {
    localStorage.setItem(storageKey, JSON.stringify(state));
  } catch (e) {
  }
}

/**
 * Subscribe to TradingView auto-save + drawing events; return flush() for unmount.
 * @returns {() => void} flush — call before widget.remove()
 */
export function bindChartAutoSave(tvWidget, storageKey) {
  let saveTimer = null;

  const persist = () => {
    try {
      tvWidget.save((state) => {
        saveChartState(storageKey, state);
      });
    } catch (e) {
    }
  };

  const persistDebounced = () => {
    if (saveTimer) clearTimeout(saveTimer);
    saveTimer = setTimeout(persist, 300);
  };

  try {
    tvWidget.subscribe('onAutoSaveNeeded', persistDebounced);
  } catch (e) {
  }

  try {
    tvWidget.subscribe('drawing_event', persistDebounced);
  } catch (e) {
    // Older charting_library builds may not expose drawing_event
  }

  return () => {
    if (saveTimer) clearTimeout(saveTimer);
    persist();
  };
}
